import { Directive, HostListener, HostBinding, EventEmitter, Output, Input } from '@angular/core';

@Directive({ selector: '[appDnd]' })
export class DragDropDirective {
  @Input() private allowed_extensions: Array<string> = [];
  @Output() private filesChangeEmiter: EventEmitter<FileList> = new EventEmitter();
  @Output() private filesInvalidEmiter: EventEmitter<FileList> = new EventEmitter();
  @HostBinding('style.background') private background = 'transparent';

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eee';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'transparent';
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'transparent';
    if (!evt.dataTransfer) {
      return;
    }
    const files: FileList = evt.dataTransfer.files;
    let valid_files: FileList = null;
    let invalid_files: FileList = null;
    if (files.length > 0) {
      Array.from(files).forEach(file => {
        const ext = file.name.split('.')[file.name.split('.').length - 1];
        if ((this.allowed_extensions.lastIndexOf(ext)) !== -1) {
          valid_files = files;

        } else {
          invalid_files = files;
        }
      });
      this.filesChangeEmiter.emit(valid_files);
      this.filesInvalidEmiter.emit(invalid_files);
    }
  }

}

